export default {
    filterSources: [
        {
            name: 'OneDine Order Type',
            shortText: 'sourceType',
            checked: true,
        },
        {
            name: 'POS Order Type',
            shortText: 'orderType',
            checked: false,
        },
        {
            name: 'POS Revenue Center',
            shortText: 'revenueCenter',
            checked: false,
        },
        {
            name: 'Sensor Group',
            shortText: 'sensorGroup',
            checked: false,
        },
    ],
    revenuesList: [
        {
            externalId: '0',
            id: 0,
            name: 'All',
            shortName: null,
        },
    ],
    orderTypesList: [
        {
            externalId: '0',
            id: 0,
            name: 'All',
            shortName: null,
        },
    ],
    nTypesList: [
        {
            externalId: '0',
            id: 0,
            name: 'All',
            shortName: null,
        },
    ],
    sensorGroupAll:[
        {
            id: 0,
            name: 'All',
        },
    ],
}